import { render, staticRenderFns } from "./orderStatementItemsSummaryBoxPrint.vue?vue&type=template&id=41b4d068&"
import script from "./orderStatementItemsSummaryBoxPrint.vue?vue&type=script&lang=ts&"
export * from "./orderStatementItemsSummaryBoxPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports